import { BASE_URL, BASE_URL_API } from "./config";
import { useAuth } from "../components/auth/AuthContext/AuthContext";
import { useNavigate } from "react-router-dom";
import { LogItem } from "./logItem";
import { expireSession } from "../components/auth/AuthContext/sessionExpiry";

export async function Call(
  endpoint: string,
  method: string,
  body?: any,
  logItem?: LogItem,
): Promise<any> {
  try {
    const token = localStorage.getItem("authToken");
    const uri = `${BASE_URL_API}${endpoint}`;

    const headers: HeadersInit = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    // Aggiungi l'header x-log-item solo se logItem ha dei dati
    if (logItem) {
      headers["x-log-item"] = JSON.stringify(logItem);
    }

    const response = await fetch(uri, {
      method,
      headers: headers,
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      // Gestisce errori di stato non OK
      const errorData = await response.json();
      if (errorData.message === "Token non valido") {
        alert(errorData.message);
        expireSession();
      }
      console.error("Errore API lato server:", errorData);
      return new Response(JSON.stringify(errorData), {
        status: response.status,
        headers: { "Content-Type": "application/json" },
      });
    } else if (logItem) {
      const logUri = `${BASE_URL_API}${"/logs/new"}`;
      const response = await fetch(logUri, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: logItem ? JSON.stringify(logItem) : undefined,
      });
    }

    return response;
  } catch (error) {
    console.error("Errore di rete:", error);
    return new Response(
      JSON.stringify({
        success: false,
        message: "Errore interno del server o server non raggiungibile",
      }),
      {
        status: 500,
        headers: { "Content-Type": "application/json" },
      },
    );
  }
}
